import { render, staticRenderFns } from "./editTransport.vue?vue&type=template&id=af185bb8&scoped=true&"
import script from "./editTransport.vue?vue&type=script&lang=js&"
export * from "./editTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af185bb8",
  null
  
)

export default component.exports